export const $ = (query, context = document) => {
  const ctx = context instanceof Node
    ? context
    : (
      document.querySelector(context)
      || document
    );

  const nodeList = typeof query === 'string'
    ? ctx.querySelectorAll(query)
    : query;

  return nodeList instanceof NodeList
    ? Array.prototype.slice.call(nodeList)
    : [nodeList];
};

const show = (query) => $(query).map((element) => {
  element.removeAttribute('hidden');
  return element;
});

const hide = (query) => $(query).map((element) => {
  element.setAttribute('hidden', true);
  return element;
});

const toggle = (query, display) => $(query).map((element) => {
  const visible = display != null
    ? !!display
    : element.hasAttribute('hidden');
  const action = visible ? show : hide;

  action(element);

  return element;
});

const render = (node, {
  style, events, children, attrs, ...props
} = {}) => {
  const element = (
    typeof node === 'string'
      ? document.createElement(node)
      : node
  );

  if (!(element instanceof Node)) {
    // eslint-disable-next-line no-console
    console.warn('Elemento inválido.', element);
    return null;
  }

  if (props) {
    Object.entries(props).forEach(([key, val]) => {
      element[key] = val;
    });
  }

  if (attrs) {
    Object.entries(attrs).forEach(([key, val]) => {
      element.setAttribute(key, val);
    });
  }

  if (style) {
    Object.entries(style).forEach(([key, val]) => {
      element.style[key] = val;
    });
  }

  if (children instanceof Array) {
    children.forEach((kid) => {
      if (kid instanceof Node) {
        element.appendChild(kid);
      }
    });
  }

  if (events) {
    Object.entries(events).forEach(([name, fn]) => {
      if (typeof name === 'string' && fn instanceof Function) {
        element.addEventListener(name, fn);
      }
    });
  }

  return element;
};

$.show = show;
$.hide = hide;
$.toggle = toggle;
$.render = render;

export const isInViewport = (elem) => {
  const {
    top, left, bottom, right,
  } = elem.getBoundingClientRect();
  return (
    top >= 0 && left >= 0
    && bottom <= (window.innerHeight || document.documentElement.clientHeight)
    && right <= (window.innerWidth || document.documentElement.clientWidth)
  );
};

export const trigger = (el, name, detail) => {
  const customEvent = window.CustomEvent && typeof window.CustomEvent === 'function';
  const event = (
    customEvent
      ? new CustomEvent(name, { detail })
      : document.createEvent('CustomEvent')
  );

  event.initCustomEvent(name, true, true, detail);

  el.dispatchEvent(event);
};
